module.exports = __webpack_public_path__ + "img/mat.0d3e825c.jpeg";